/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    action: PropTypes.bool,
    icon: PropTypes.bool,
    color: PropTypes.oneOf([
        'error',
        'success',
        'default',
        'info',
        'warning',
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
    action: false,
    icon: false,
    color: 'default',
};

const Tag = (props) => {
    const classNames = [
        'c-tag',
        `c-tag--${props.color}`,
        props.action ? 'c-tag--action' : '',
        props.icon ? 'c-tag--icon' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Tag.propTypes = propTypes;

Tag.defaultProps = defaultProps;

export default Tag;
